import React, {useEffect, useState} from "react";
import {StarIcon} from "@heroicons/react/24/solid";
import {StarIcon as StarOutlineIcon} from "@heroicons/react/24/outline";
import {Tooltip, TooltipContent, TooltipProvider, TooltipTrigger} from "../../../../shadCn/components/ui/tooltip";
import "./serviceRequestFeedback.css";

const STAR_COUNT = 5;

function StarButton({filled, score, onSelect, readOnly = false}) {
    const Icon = filled ? StarIcon : StarOutlineIcon;

    const star = (
        <button
            type="button"
            className="service-star-rating__star"
            aria-label={`${score}점`}
            disabled={readOnly}
            onClick={readOnly ? undefined : () => onSelect(score)}
        >
            <Icon
                className={[
                    "service-star-rating__icon",
                    filled ? "service-star-rating__icon--filled" : "service-star-rating__icon--empty",
                ].join(" ")}
                aria-hidden
            />
        </button>
    );

    if (readOnly) {
        return star;
    }

    return (
        <Tooltip>
            <TooltipTrigger asChild>{star}</TooltipTrigger>
            <TooltipContent>{score}점</TooltipContent>
        </Tooltip>
    );
}

const ServiceStarRating = ({target, setData, defaultValue, className, callback}) => {
    const [rating, setRating] = useState(defaultValue ?? 0);

    useEffect(() => {
        setRating(defaultValue ?? 0);
    }, [defaultValue]);

    useEffect(() => {
        if (setData) {
            setData((prev) => ({...prev, [target]: rating}));
        }
    }, [rating, setData, target]);

    const handleRatingChange = (newRating) => {
        setRating(newRating);
        if (callback) {
            callback(newRating, target);
        }
    };

    return (
        <TooltipProvider delayDuration={100}>
            <div className={`service-star-rating ${className ?? ""}`.trim()}>
                {Array.from({length: STAR_COUNT}, (_, index) => {
                    const score = index + 1;
                    return (
                        <StarButton
                            key={score}
                            score={score}
                            filled={score <= rating}
                            onSelect={handleRatingChange}
                        />
                    );
                })}
            </div>
        </TooltipProvider>
    );
};

const RatedStart = ({defaultValue, className, starClassName}) => {
    const rating = Number(defaultValue) || 0;

    return (
        <div className={`service-star-rating service-star-rating--readonly ${className ?? ""}`.trim()}>
            {Array.from({length: STAR_COUNT}, (_, index) => {
                const score = index + 1;
                const filled = score <= rating;
                const Icon = filled ? StarIcon : StarOutlineIcon;

                return (
                    <span key={score} className="service-star-rating__star">
                        <Icon
                            className={[
                                starClassName ?? "service-star-rating__icon",
                                filled ? "service-star-rating__icon--filled" : "service-star-rating__icon--empty",
                            ].join(" ")}
                            aria-hidden
                        />
                    </span>
                );
            })}
        </div>
    );
};

export {ServiceStarRating, RatedStart};
